// extracted by mini-css-extract-plugin
export var divider = "_3x-0";
export var dividerText = "_3x-1";